module.exports = __webpack_public_path__ + "img/general_empty_icon@2x.afe06268.png";